import { Quote, CheckCircle2 } from "lucide-react";

export const TestimonialCard = ({ t, active = true }) => {
  const initials = t.name
    .split(" ")
    .map((w) => w[0])
    .slice(0, 2)
    .join("");
  return (
    <figure
      data-testid="testimonial-card"
      className={`flex h-full flex-col rounded-3xl border p-8 transition-all duration-500 ${
        active
          ? "border-[#1C7543]/30 bg-white shadow-[0_20px_60px_rgba(14,58,40,0.12)]"
          : "border-[#07130C]/10 bg-white/70"
      }`}
    >
      <Quote className="h-6 w-6 text-[#D3B74D]" />
      <blockquote className="mt-5 flex-1 text-base leading-relaxed text-[#07130C]/75">
        “{t.quote}”
      </blockquote>
      {t.result && (
        <span className="mt-5 inline-flex w-fit items-center gap-1.5 rounded-full bg-[#1C7543]/10 px-3.5 py-1.5 text-[11px] font-semibold text-[#1C7543]">
          <CheckCircle2 className="h-3.5 w-3.5" /> {t.result}
        </span>
      )}
      <figcaption className="mt-6 flex items-center gap-4 border-t border-[#07130C]/8 pt-6">
        <span className="flex h-11 w-11 items-center justify-center rounded-full bg-gradient-to-br from-[#3CBE6E] to-[#D3B74D] font-display text-sm font-bold text-white">
          {initials}
        </span>
        <span>
          <span className="block text-sm font-semibold text-[#07130C]">{t.name}</span>
          <span className="block text-xs text-[#07130C]/55">
            {t.designation} · {t.industry}
          </span>
        </span>
      </figcaption>
    </figure>
  );
};
